<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="60px" :model="searchForm" :rules="rules" ref="searchForm" @change="onSearch">
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.monthCode" type="month" value-format="yyyyMM" placeholder="选择月"> </el-date-picker>
          </el-form-item>
          <el-form-item label="工号">
            <el-input v-model.trim="searchForm.workNo" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model.trim="searchForm.userName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="岗位">
            <el-select v-model="searchForm.workJobs" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="(item,index) in workJobsList" :label="item.workJobs" :key="index" :value="item.workJobs"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="edit(false)">编辑</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        @selection-change="seletionChange"
        :data="tableData.records"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
        row-key="dataId"
      >
        <el-table-column type="selection" width="40" :reserve-selection="true" fixed="left"></el-table-column>
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :fixed="item.fixed"
          :min-width="item.width"
          :show-overflow-tooltip="item.label != '岗位'"
          v-for="item in columnData"
          :key="item.label"
          :align="item.children ? 'center' : 'center'"
        >
          <!-- 二级表头 -->
          <el-table-column
            show-overflow-tooltip
            v-show="item.childList"
            v-for="(data, index) in item.children"
            :label="data.titleName"
            :prop="data.propertyName"
            :width="data.displayWidth"
            :key="data.propertyName + index"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row[item.prop] || scope.row[data.propertyName] }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <edit-dialog :visible.sync="isShowEdit" v-if="isShowEdit" :rowData="rowData" @success="onSearch" />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from "@/utils/tableMixin";
import editDialog from "./edit.vue";
import axios from "@/utils/axiosInstance";
import { downloadFile } from "@/utils";
import moment from "moment";
export default {
  name: "photographySalaryAccounting",
  mixins: [tableMixin, pagePathMixin],
  components: { editDialog },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      loading: false,
      searchForm: {
        workJobs: "",
      },
      isShowEdit: false,
      rowData: [],
      tableSeletion: [],
      workJobsList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
    this.getWorkJobsList()
  },
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.init();
    },
    async init(type) {
      this.loading = true;
      this.tableReload = false;
      this.$nextTick((_) => {
        this.tableReload = true;
      });
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        ...this.searchForm,
      };
      this.searchFormData = data;
      this.$q.newProduct
        .shootingAccountSumInfoSearch({ data: data })
        .then((res) => {
          res.data.titleList.forEach((v) => {
            this.columnData.push({
              label: v.titleName,
              prop: v.propertyName,
              width: v.displayWidth,
              sortable: v.sortable == "1" ? "custom" : false,
              span: false,
              fixed: v.fixed == 1 ? "left" : false,
            });
          });
          this.columnData = [];
          let columnData = [];
          let data = this.handlerDatas(res.data.titleList);
          data.map((v) => {
            if (v.parentName) {
              columnData.push(v);
            }
          });
          columnData.unshift(...data[0].children.slice(0,6));
          columnData.push(...data[0].children.slice(-4))
          columnData.forEach((v) => {
            this.columnData.push({
              label: v.titleName,
              prop: v.propertyName,
              width: v.displayWidth,
              sortable: v.sortable == "1" ? "custom" : false,
              span: false,
              fixed: v.fixed == 1 ? "left" : false,
              children: v.children || null,
            });
          });
          this.tableData = res.data.dynamicData;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    handlerDatas(arr) {  
      let obj = {}
      arr.forEach((item, index) => {
        let { parentName } = item
        if (!obj[parentName]) {
          obj[parentName] = {
            parentName,
            children: [],
            titleName: parentName ? parentName : item.titleName,
            propertyName: parentName ? parentName : item.propertyName,
            displayWidth: item.displayWidth
          }
        }
        obj[parentName].children.push(item)
      })
      let data = Object.values(obj) // 最终输出
      return data
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.searchForm = {
        workJobs: ""
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    seletionChange(val) {
      this.tableSeletion = val;
    },
    edit(row) {
      if (!row && !this.tableSeletion.length) {
        this.$message.error("请选择后在进行操作！");
        return;
      }
      this.rowData = !row ? this.tableSeletion : [row];
      this.isShowEdit = true;
    },
    // 导出
    async exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$q.newProduct.shootingAccountSumInfoExport({ data: this.searchFormData, options: { responseType: "blob" } }).then((res) => {
        let fileName = "摄影工资核算汇总" + moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        this.blobDownload(res, `${fileName}.xlsx`);
        loading.close();
      });
    },
    getWorkJobsList() {
      let data = { ...this.currencyForm };
      data.reportCode = "newProductShootingWorkJobsList";
      axios.post(`/ec-pc-api/custom/reports/data/newProductShootingWorkJobsList`, data).then((res) => {
        this.workJobsList = res.data.list;
        console.log(this.workJobsList);
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>
